import { sortBy } from 'libraries/lodash'
import {
  SET_LEGISLATION_FOLDERS,
  SET_LEGISLATION_FOLDERS_MAP,
  SET_LEGISLATION_ACT_ID_MAP,
  SET_LEGISLATION_ACT,
  SET_LEGISLATION_ACTS,
  SET_LEGISLATION_PATH,
  SET_LEGISLATION_ACT_NODES,
  SET_LEGISLATION_ACT_HOVER_ICON_MAP,
  SET_LEGISLATION_SHOW_FAVOURITES_ONLY,
  SET_LEGISLATION_KEYWORD,
  SET_LEGISLATION_SELECTED_AOLS
} from './types'
import { AppDispatch } from 'redux/store'
import { LegislationActNode, LegislationFolder, LegislationAct } from 'interfaces/legislation'
import { LEGISLATION_FAVOURITES_ONLY_KEY } from 'constants/storage-keys'

export const setLegislationPath = (path: string): { type: typeof SET_LEGISLATION_PATH, path: string } => ({
  type: SET_LEGISLATION_PATH,
  path
})

export const setLegislationAct = (act: string) => {
  return (dispatch: AppDispatch, _: any) => {
    const actId = act !== '' ? act.split(':')[0].concat(':::::') : ''
    dispatch({
      type: SET_LEGISLATION_ACT,
      act: actId
    })
    dispatch(setLegislationPath(act))
  }
}

const setLegislationActHoverIconMap = (actNodes: Record<string, LegislationActNode>) => {
  return (dispatch: AppDispatch, _: any) => {
    const actHoverIconList = Object.entries(actNodes)
      .filter(([_, node]) => node.hoverIcon)

    const actHoverIconMap = new Map(actHoverIconList)

    dispatch({
      type: SET_LEGISLATION_ACT_HOVER_ICON_MAP,
      actHoverIconMap
    })
  }
}

export const setLegislationActNodes = (actNodes: Record<string, LegislationActNode>) => {
  return (dispatch: AppDispatch, _: any) => {
    dispatch(setLegislationActHoverIconMap(actNodes) as any)

    dispatch({
      type: SET_LEGISLATION_ACT_NODES,
      actNodes
    })
  }
}

const setLegislationActIdMapFromFolders = (folders: LegislationFolder[]): (dispatch: AppDispatch, _: any) => void => {
  const actIdMap = new Map()

  for (let i = 0; i < folders.length; i++) {
    const categories = folders[i].categories
    for (let j = 0; j < categories.length; j++) {
      const legislation = categories[j].legislation
      for (let k = 0; k < legislation.length; k++) {
        const { id, number, title, actNote, category, folder, level, levelName, archive, hidden, isComplete } = legislation[k]
        actIdMap.set(id, { number, title, actNote, folderName: folder, category, level, levelName, archive, hidden, isComplete })
      }
    }
  }

  const acts = Array.from(actIdMap).map(([id, values]) => ({ id, ...values })) // TODO check if valid for IE
  const sortedActs = sortBy(acts, ({ title }) => title)

  return (dispatch: AppDispatch, _: any) => {
    dispatch({
      type: SET_LEGISLATION_ACT_ID_MAP,
      actIdMap
    })
    dispatch(setLegislationActs(sortedActs))
  }
}

const setLegislationActs = (acts: LegislationAct[]): { type: typeof SET_LEGISLATION_ACTS, acts: LegislationAct[] } => ({
  type: SET_LEGISLATION_ACTS,
  acts
})

const setLegislationFoldersMap = (folders: LegislationFolder[]): (dispatch: AppDispatch, _: any) => void => {
  const allFolders = Array.isArray(folders) ? folders.flat() : folders
  const foldersMap = allFolders.length > 0 ? new Map(allFolders.map(folder => [folder.name, folder.categories])) : undefined

  return (dispatch: AppDispatch, _: any) => {
    dispatch({
      type: SET_LEGISLATION_FOLDERS_MAP,
      foldersMap
    })
  }
}

export const setLegislationFolders = (folders: LegislationFolder[]) => {
  return (dispatch: AppDispatch, _: any) => {
    dispatch(setLegislationActIdMapFromFolders(folders) as any)
    dispatch(setLegislationFoldersMap(folders) as any)
    dispatch({
      type: SET_LEGISLATION_FOLDERS,
      folders
    })
  }
}

export const setLegislationKeyword = (keyword: string): { type: typeof SET_LEGISLATION_KEYWORD, keyword: string } => ({
  type: SET_LEGISLATION_KEYWORD,
  keyword
})

export const setLegislationShowFavouritesOnly = (show: boolean): { type: typeof SET_LEGISLATION_SHOW_FAVOURITES_ONLY, showFavouritesOnly: boolean } => {
  localStorage.setItem(LEGISLATION_FAVOURITES_ONLY_KEY, JSON.stringify(show))
  return {
    type: SET_LEGISLATION_SHOW_FAVOURITES_ONLY,
    showFavouritesOnly: show
  }
}

export const setLegislationSelectedAols = (selectedAols: string[]): { type: typeof SET_LEGISLATION_SELECTED_AOLS, selectedAols: string[] } => ({
  type: SET_LEGISLATION_SELECTED_AOLS,
  selectedAols
})
